import { useContext } from 'react';
import { AuthenticationContext } from './AuthenticationContext.js';

function useIsAdmin() {
    const { currentUser } = useContext(AuthenticationContext);
    return currentUser?.isAdmin;
}
function useIsInternalUser() {
    const { currentUser } = useContext(AuthenticationContext);
    return currentUser?.email.includes('@chronosphere.io');
}
function useAuth() {
    const auth = useContext(AuthenticationContext);
    return auth;
}
function useIsServiceAccountUser() {
    const { currentUser } = useContext(AuthenticationContext);
    return currentUser?.email.includes('@serviceaccount.chronosphere.io');
}
/**
 * Hook to get the current user
 */ function useCurrentUser() {
    const auth = useAuth();
    const currentUser = auth.currentUser || null;
    return [
        currentUser,
        auth.isLoading
    ];
}
function useIsAuthenticated() {
    const { currentUser } = useContext(AuthenticationContext);
    return currentUser !== undefined;
}

export { useAuth, useCurrentUser, useIsAdmin, useIsAuthenticated, useIsInternalUser, useIsServiceAccountUser };
//# sourceMappingURL=permissions.js.map
